import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

const FAQSection = () => {
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null)

  const toggleFaq = (index: number) => {
    setExpandedFaq(expandedFaq === index ? null : index)
  }

  const faqs = [
    {
      question: "Does this track customers personally?",
      answer: "No. FlowBeatIQ only detects anonymous Wi-Fi signals. No cameras, no personal data, no identification."
    },
    {
      question: "Will this affect my existing Wi-Fi network?",
      answer: "No. The sensor is completely passive and does not connect to or interfere with your Wi-Fi."
    },
    {
      question: "What happens if I cancel?",
      answer: "You can cancel anytime. There are no contracts or long-term commitments."
    },
    {
      question: "How accurate is it?",
      answer: "Our system is accurate enough to spot trends and patterns, with 80–90% consistency in most environments. Perfect for business decisions — without enterprise costs."
    },
    {
      question: "What if customers turn off Wi-Fi?",
      answer: "Most people don't. And even if some do, the trends remain reliable."
    },
    {
      question: "Do I need technical skills?",
      answer: "Nope. Plug it in, log into your dashboard, and you're done. If you provide your Wi-Fi details at checkout, we pre-configure your sensor so it's literally plug-and-play. Prefer to set it up yourself? Setup takes under 10 minutes."
    },
    {
      question: "What about privacy?",
      answer: "We only detect anonymous Wi-Fi signals. No personal information, no faces, no tracking. Ever."
    },
    {
      question: "What if I have multiple locations?",
      answer: "You can add as many sensors as you like. Manage them all from one dashboard."
    }
  ]

  return (
    <section id="faq" className="section-padding bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
          You asked. We answered.
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200"
                onClick={() => toggleFaq(index)}
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 flex-shrink-0 ${
                  expandedFaq === index ? 'rotate-180' : ''
                }`} />
              </button>
              <div className={`transition-all duration-300 ease-in-out ${
                expandedFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              } overflow-hidden`}>
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQSection
